import { FC, memo, useMemo } from 'react'
import { Button, Tooltip, ButtonProps } from '@chakra-ui/react'
import { useValidatePermissions } from 'hooks'

type Props = ButtonProps & {
  customTooltipLabel?: string
  customDisableCondition?: boolean | null
  permissions?: (string | undefined)[]
}

const ButtonWithPermission: FC<Props> = ({
  customTooltipLabel = 'Você não tem permissão',
  customDisableCondition = null,
  permissions,
  children,
  ...buttonProps
}) => {
  const { validatePermissions } = useValidatePermissions()

  const hasPermission = useMemo(() => {
    return validatePermissions(permissions)
  }, [permissions])

  const condition = customDisableCondition === null ? hasPermission : customDisableCondition

  return (
    <Tooltip isDisabled={condition} label={customTooltipLabel}>
      <Button isDisabled={!condition} minWidth="min-content" {...buttonProps}>
        {children}
      </Button>
    </Tooltip>
  )
}

export default memo(ButtonWithPermission)
